import { Check } from "lucide-react";
import { rupiah } from "@/lib/format";
import { packageLimits, tierRows } from "@/lib/pricing";

export const PriceTable = ({ pkg }) => {
  const rows = tierRows(pkg);
  const [, high] = packageLimits(pkg);
  if (!rows.length) {
    return (
      <div className="flex items-baseline justify-between font-mono text-sm">
        <span className="text-neutral-500">Per orang</span>
        <span className="text-gold-light">{rupiah(pkg.price_per_person)}</span>
      </div>
    );
  }
  return (
    <div className="space-y-1.5 font-mono text-sm">
      {rows.map((t) => (
        <div key={t.pax} className="flex items-baseline justify-between gap-4">
          <span className="text-neutral-500">{t.pax} pax</span>
          <span className="flex-1 border-b border-dashed border-white/10" />
          <span className="text-gold-light">{rupiah(t.price)}</span>
        </div>
      ))}
      {pkg.extra_pax_price > 0 && (
        <p className="pt-1 text-xs text-neutral-500">+{rupiah(pkg.extra_pax_price)} per pax tambahan (maks. {high})</p>
      )}
    </div>
  );
};

const PackageOption = ({ pkg, active, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    data-testid={`package-option-${pkg.id}`}
    className={`flex flex-col rounded-2xl border p-5 text-left transition-[border-color,background-color] duration-300 ${
      active ? "border-gold bg-gold/[0.07]" : "border-white/10 bg-white/[0.02] hover:border-white/30"
    }`}
  >
    <div className="flex items-start justify-between gap-3">
      <div>
        <p className="font-display text-xl leading-tight">{pkg.name}</p>
        <p className="mt-1 text-xs text-neutral-500">{pkg.duration_label || `${pkg.duration_days} hari`}</p>
      </div>
      <span className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full border ${active ? "border-gold bg-gold text-black" : "border-white/20"}`}>
        {active && <Check className="h-3.5 w-3.5" />}
      </span>
    </div>
    <div className="mt-5 border-t border-white/10 pt-4">
      <PriceTable pkg={pkg} />
    </div>
  </button>
);

export const PackagePicker = ({ packages, value, onChange }) => (
  <div data-testid="package-picker">
    <p className="overline-label">Langkah 1</p>
    <h2 className="mt-2 font-display text-3xl">Pilih paket</h2>
    <p className="mt-2 text-sm text-neutral-500">Harga di tabel adalah total untuk jumlah pax tersebut.</p>
    <div className="mt-6 grid gap-4 sm:grid-cols-2">
      {packages.map((p) => (
        <PackageOption key={p.id} pkg={p} active={p.id === value} onClick={() => onChange(p.id)} />
      ))}
    </div>
  </div>
);
